export const BASE_URL = '/NS11_QC/WS/NSWS';
export const IMAGE_URL = 'http://sepdvs129.rd.ibs.net:8095';
export const REDUX_PERSIST_KEY = 'root';
export const BASE_URL_KEY = 'base_url';
export const IMAGE_URL_KEY = 'image_url';
export const SERVER_IMAGE_BASE_URL = 'image_base_url';

// export const BASE_URL = 'http://sepdvs149.rd.ibs.net:8090/NS8/WS/NSWS';
